import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';

/**
 * Collapsible beginner-help box for CW wizard steps (TM-1000001889).
 *
 * Wraps the large "Hilfetext" info boxes the steps show to first-time users. In normal mode the
 * box is fully expanded (beginners get the full guidance). In Express-Modus (Schnellerfassung) a
 * power user does not want to be slowed down by that help, so the box collapses to a small (i)
 * marker by default and can still be expanded on demand (Benjamin "collapse help in Express" minor).
 *
 * Usage in a step template (replacing the inline help div):
 *   <mvs-cw-case-help-box [expressMode]="expressMode">
 *       Wählen Sie zuerst den <b>Abschlussweg</b> ...
 *   </mvs-cw-case-help-box>
 *
 * The projected content is the German help text. Code stays English.
 */
@Component({
    selector: 'mvs-cw-case-help-box',
    templateUrl: './cw-case-help-box.component.html',
    styleUrls: ['./cw-case-help-box.component.scss'],
    standalone: false
})
export class CwCaseHelpBoxComponent implements OnChanges {

    /**
     * When true (Express-Modus), the help box starts collapsed to a small (i) toggle.
     * When false, the help box is always fully shown and the toggle is hidden.
     */
    @Input() expressMode: boolean = false;

    /** Whether the full help text is currently visible. */
    expanded: boolean = true;

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['expressMode']) {
            // Collapse by default in Express, expand by default otherwise.
            this.expanded = !this.expressMode;
        }
    }

    toggle(): void {
        this.expanded = !this.expanded;
    }
}
